/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TransactionsTransactionIn } from './TransactionsTransactionIn';
import {
    TransactionsTransactionInFromJSON,
    TransactionsTransactionInFromJSONTyped,
    TransactionsTransactionInToJSON,
} from './TransactionsTransactionIn';

/**
 * 
 * @export
 * @interface MoneyInSubscriptionInitOutput
 */
export interface MoneyInSubscriptionInitOutput {
    /**
     * 
     * @type {TransactionsTransactionIn}
     * @memberof MoneyInSubscriptionInitOutput
     */
    transactions?: TransactionsTransactionIn;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInSubscriptionInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInSubscriptionInitOutput interface.
 */
export function instanceOfMoneyInSubscriptionInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInSubscriptionInitOutputFromJSON(json: any): MoneyInSubscriptionInitOutput {
    return MoneyInSubscriptionInitOutputFromJSONTyped(json, false);
}

export function MoneyInSubscriptionInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInSubscriptionInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'transactions': !exists(json, 'transactions') ? undefined : TransactionsTransactionInFromJSON(json['transactions']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInSubscriptionInitOutputToJSON(value?: MoneyInSubscriptionInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'transactions': TransactionsTransactionInToJSON(value.transactions),
        'error': value.error,
    };
}

